import { getCookie } from 'react-use-cookie'

import { UserRole } from './PortalContext'

const parseJwt = (token: any) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
  return JSON.parse(jsonPayload)
}

export const acquireAccessToken = async (msalInstance: any) => {
  const activeAccount = msalInstance.getActiveAccount() // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts()

  if (!activeAccount && accounts.length === 0) {
    /*
     * User is not signed in. Throw error or wait for user to login.
     * Do not attempt to log a user in outside of the context of MsalProvider
     */
  }
  const request = {
    scopes: ['api://63a8c28a-6162-4b5d-b552-9bd792ff3d2d/Rating.Manage'],
    account: activeAccount || accounts[0]
  }

  const authResult = await msalInstance.acquireTokenSilent(request)

  return authResult.accessToken
}

export const getUserRoleFromAccessToken = (accessToken: any) => {
  let role = UserRole.ApplicationManager
  const payload = parseJwt(accessToken)
  if ((payload as any)?.groups?.length > 0) {
    const payloadGroup = (payload as any).groups
    // every person is by default an application manager
    payloadGroup.map((element: any) => {
      if (element === '45bb9f2e-5c08-4618-a698-ab969630edeb') {
        role = UserRole.KeyUser
      } else if (element === '9ce473c6-98ca-435c-89ca-3357b34944b2') {
        role = UserRole.Manager
      }
    })
  }
  return role
}

export const getActiveAccessToken = () => {
  const token = getCookie('accessToken')
  return token
}
